module.exports = __webpack_public_path__ + "web/img/stationed-bg.2c42452f.png";